import React from 'react';
import { createPortal } from 'react-dom';
import { AlertCircle, X } from 'lucide-react';

const ExpiredSubscriptionModal = ({ isOpen, onClose, onSubscribe }) => {
  if (!isOpen) return null;

  const handleSubscribeClick = () => {
    if (onSubscribe) {
      onSubscribe();
    } else if (onClose) {
      onClose();
    }
  };

  const modalContent = (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        margin: 0,
        padding: '1rem'
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget && onClose) {
          onClose();
        }
      }}
    >
      <div
        className="bg-white rounded-2xl w-full max-w-lg shadow-2xl border border-gray-100"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-start p-6 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl bg-red-50 text-red-600 flex items-center justify-center">
              <AlertCircle className="w-6 h-6" />
            </div>
            <div>
              <h3 className="text-xl font-semibold text-gray-900">Subscription Expired</h3>
              <p className="text-sm text-gray-500">
                Access to Candor chat features is currently restricted.
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full bg-gray-100 text-gray-600 flex items-center justify-center hover:bg-gray-200 transition-colors"
            aria-label="Close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <p className="text-gray-800 text-base leading-relaxed">
            Your Subscription is expired please Subscribe to use the Candor Chat Features.
            Reactivating your plan instantly restores full access to AI assistance,
            analytics, and priority support inside the Candor platform.
          </p>

          <div className="bg-red-50 border border-red-100 rounded-xl p-4 text-sm text-red-700">
            <p className="font-medium mb-1">Why you are seeing this</p>
            <p>Your current billing cycle has ended without a renewal on file.</p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-end gap-3 p-6 border-t border-gray-100">
          <button
            onClick={onClose}
            className="w-full md:w-auto px-5 py-2.5 rounded-xl font-semibold border border-gray-200 text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Maybe Later
          </button>
          <button
            onClick={handleSubscribeClick}
            className="w-full md:w-auto px-5 py-2.5 rounded-xl font-semibold text-white bg-gradient-to-r from-red-500 to-orange-500 shadow-lg shadow-red-200 hover:opacity-90 transition-all"
          >
            Subscribe Now
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default ExpiredSubscriptionModal;

